'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCHABLE_ATTRIBUTES = exports.LOGIN_ATTRIBUTES = exports.DUPLICATE_ATTRIBUTES_WITH_PASSWORD = exports.DUPLICATE_ATTRIBUTES = exports.configureModel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _validator = require('@nettoken/validator');

var _validator2 = _interopRequireDefault(_validator);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _Model2 = require('./Model');

var _Model3 = _interopRequireDefault(_Model2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This document is the property of Nettoken Ltd.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * It is considered confidential and proprietary.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This document may not be reproduced or transmitted in any form,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * in whole or in part, without the express written permission of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Nettoken Ltd.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var t = void 0;
var configureModel = exports.configureModel = function configureModel(translate) {
  return t = translate;
};

var Credential = function (_Model) {
  _inherits(Credential, _Model);

  function Credential() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Credential);

    var _this = _possibleConstructorReturn(this, (Credential.__proto__ || Object.getPrototypeOf(Credential)).call(this, {
      addedFrom: props.addedFrom || '',
      accountId: props.accountId || '',
      cookieUrl: props.cookieUrl || '',
      domain: props.domain || '',
      email: props.email || '',
      groupId: props.groupId || '',
      id: props.id || (0, _v2.default)(),
      loginUrl: props.loginUrl || props.domain || '',
      note: props.note || '',
      meta: props.meta || '',
      name: props.name || props.domain || '',
      password: props.password || '',
      phone: props.phone || '',
      picture: props.picture || '',
      privacyUrl: props.privacyUrl || '',
      publicKey: props.publicKey || '',
      secretKey: props.secretKey || '',
      shared: props.shared || false,
      externalAccount: props.externalAccount || false,
      sharedByUserName: props.sharedByUserName || props.sharedByUser || false,
      username: props.username || '',
      invitationId: props.invitationId || '',
      accepted: props.accepted === undefined ? true : props.accepted,
      sharedByUserId: props.sharedByUserId || '',
      sharedByUserPublicKey: props.sharedByUserPublicKey || '',
      sharedByUserPhone: props.sharedByUserPhone || '',
      dashboardSpaceId: props.dashboardSpaceId || '',
      sharedId: props.sharedId || '',
      sharedByDashboard: props.sharedByDashboard || '',
      usersSharedWith: props.usersSharedWith || []
    }));

    if (!t) {
      console.warn('You are creating a new Credential model without configuring it first.');
    }
    return _this;
  }

  _createClass(Credential, [{
    key: 'attachGlobalData',
    value: function attachGlobalData(account) {
      var data = {
        accountId: account.id || '',
        cookieUrl: account.cookieUrl || '',
        domain: account.domain || '',
        loginUrl: account.loginUrl || '',
        note: account.note || '',
        name: account.name || '',
        picture: account.picture || '',
        privacyUrl: account.privacyUrl || '',
        dashboardSpaceId: account.dashboardSpaceId || '',
        sharedId: account.sharedId || '',
        usersSharedWith: account.usersSharedWith || []
      };
      this.setState(data, false);
    }
  }, {
    key: 'validate',
    value: function validate() {
      return _get(Credential.prototype.__proto__ || Object.getPrototypeOf(Credential.prototype), 'validate', this).call(this, [{
        key: 'loginUrl',
        tests: [{
          check: _validator2.default.url,
          error: function error() {
            return t('error.credential.invalidUrl');
          }
        }]
      }, {
        key: 'name',
        tests: [{
          check: _validator2.default.credentialNameMax,
          error: function error() {
            return t('error.credential.nameTooLong', { limit: _validator.CREDENTIAL_NAME_MAX_LENGTH });
          }
        }]
      }]);
    }
  }]);

  return Credential;
}(_Model3.default);

exports.default = Credential;

// We can compare two credentials to determine whether one is a duplicate of
// the other. We do this by checking each of these attributes and looking at
// how similar both credentials are.

var DUPLICATE_ATTRIBUTES = exports.DUPLICATE_ATTRIBUTES = ['email', 'phone', 'username'];

var DUPLICATE_ATTRIBUTES_WITH_PASSWORD = exports.DUPLICATE_ATTRIBUTES_WITH_PASSWORD = [].concat(DUPLICATE_ATTRIBUTES, ['password']);

var LOGIN_ATTRIBUTES = exports.LOGIN_ATTRIBUTES = ['email', 'password', 'phone', 'username'];

// We can search user's credentials. Only these
// attributes will be included in the search.
var SEARCHABLE_ATTRIBUTES = exports.SEARCHABLE_ATTRIBUTES = ['email', 'name', 'phone', 'username'];